export default __webpack_public_path__ + "static/media/jane-churchyard-benefits-3.b27ddac2.jpg";